import React, { useState, Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { read } from "Helpers/LocalStorage";
import PageTitle from "Components/PageTitle/PageTitle";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import Translator from "Languages/Utility/Translator";
import UserTable from "./components/UserTable";
import ManageUserGroup from "./components/ManageUserGroup/ManageUserGroup";
import { selectUserGroup } from "Stores/actions";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import ManageUserSupervisor from "./components/ManageUserSupervisor/ManageUserSupervisor";

function Users() {
  const { userGroupDataPagination } = useSelector((state) => ({
    userGroupDataPagination: state.user.userGroupDataPagination,
  }));
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = {
          Key: read("groupKey"),
          KeyUs: read("userKey"),
          Limit: userGroupDataPagination.Limit,
          Page: userGroupDataPagination.Page,
          Name: "",
        };
        await dispatch(selectUserGroup(params));
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <div className="page-top-title-button my-2">
        <PageTitle title={<Translator id="Manage_User" />} />
        <div className="top-buttons">
          <ManageUserSupervisor />
          <ManageUserGroup />
          {/*<AddUser />*/}
        </div>
      </div>
      <MuiPaper className="mb-5">
        <UserTable />
      </MuiPaper>
    </Fragment>
  );
}

export default Users;
